import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { PromptComponentComponent } from './prompt-component/prompt-component.component';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private promptEvent: any;
  constructor(
    private bottomSheet: MatBottomSheet,
    private platform: Platform
  ) {}

  public initPwaPrompt() {
    if (this.platform.ANDROID || this.platform.isBrowser) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.promptEvent = event;
        this.openPromptComponent('android');
      });
    }
    if (this.platform.IOS) {
      const isInStandaloneMode =
        'standalone' in window.navigator && window.navigator['standalone'];
      if (!isInStandaloneMode) {
        this.openPromptComponent('ios');
      }
    }
  }

  private openPromptComponent(mobileType: 'ios' | 'android') {
    timer(500)
      .pipe(take(1))
      .subscribe(() => {
        this.bottomSheet.open(PromptComponentComponent, {
          panelClass: 'custom-prompt-bottomsheet',
          data: { mobileType, promptEvent: this.promptEvent },
        });
      });
  }
}
